/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFOTTResponse
 */
export interface CRSFOTTResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFOTTResponse
     */
    ott: string;
}

/**
 * Check if a given object implements the CRSFOTTResponse interface.
 */
export function instanceOfCRSFOTTResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ott" in value;

    return isInstance;
}

export function CRSFOTTResponseFromJSON(json: any): CRSFOTTResponse {
    return CRSFOTTResponseFromJSONTyped(json, false);
}

export function CRSFOTTResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFOTTResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ott': json['ott'],
    };
}

export function CRSFOTTResponseToJSON(value?: CRSFOTTResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ott': value.ott,
    };
}

